module.exports = __webpack_public_path__ + "static/img/available.6a1cfc81.png";